import React, { ButtonHTMLAttributes } from 'react';

interface CivicButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  children: React.ReactNode;
}

export default function CivicButton({
  variant = 'primary',
  fullWidth = false,
  children,
  className = '',
  ...props
}: CivicButtonProps) {
  const baseClasses = 'py-3 px-4 font-medium rounded-full transition-all duration-200';

  const variantClasses = {
    primary: 'bg-transparent border text-[#40E0D0] hover:bg-[rgba(64,224,208,0.10)] active:bg-[rgba(64,224,208,0.14)]',
    secondary: 'bg-transparent border text-[rgba(255,255,255,0.80)] hover:bg-[rgba(255,255,255,0.06)] active:bg-[rgba(255,255,255,0.10)]',
  };

  const borderStyles = {
    primary: { borderColor: 'rgba(64, 224, 208, 0.45)' },
    secondary: { borderColor: 'rgba(255, 255, 255, 0.10)' },
  };

  const widthClass = fullWidth ? 'w-full' : '';

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${widthClass} ${className}`}
      style={borderStyles[variant]}
      {...props}
    >
      {children}
    </button>
  );
}
